import React, { useState } from "react";
import Dropdown from "../../../components/Dropdown";
import OneCheckBox from "../../../components/OneCheckBox";
import GrowthTable from "./GrowthTable";
import ButtonPrimary from "../../../components/ButtonPrimary";
import TableLogComponents from "../../../components/TableLogComponents";
export default function DialogAddGrowth({
  isShow,
  backgroundClick,
  cancelClick,
}) {
  return (
    <div className="box-position-dialog" id={isShow ? "show-dialog" : ""}>
      <div
        className="box-cover-dialog-background"
        onClick={backgroundClick}
      ></div>
      <div className="box-dialog">
        <div className="row-jcct-pt2">
          <p style={{ color: "#134e96" }} className="txt-main-content4">
            Add Growth
          </p>
        </div>
        <div className="box-table-inside-dialog">
          <TableLogComponents
            columns={[
              {
                title: "No",
                dataIndex: "no",
                key: "no",
              },
              {
                title: "First Name",
                dataIndex: "firstname",
                key: "firstname",
              },
              {
                title: "Last Name",
                dataIndex: "lastname",
                key: "lastname",
              },
              {
                title: "ID",
                dataIndex: "id",
                key: "id",
              },
            ]}
            dataSource={[
              {
                no: "1",
                firstname: "firstname 1",
                lastname: "lastname 1",
                id: "ID 1",
              },
              {
                no: "1",
                firstname: "firstname 1",
                lastname: "lastname 1",
                id: "ID 1",
              },
              {
                no: "1",
                firstname: "firstname 1",
                lastname: "lastname 1",
                id: "ID 1",
              },
              {
                no: "1",
                firstname: "firstname 1",
                lastname: "lastname 1",
                id: "ID 1",
              },
            ]}
          />
        </div>
        <div className="row-jcsb-px2-gab2">
          <div className="col-jcfs">
            <p className="txt-main-content4">Height</p>
            <div className="row-jcct-gab2">
              <input className="text-field"></input>
              <p className="txt-main-content4">cm</p>
            </div>
          </div>
          <div className="col-jcfs">
            <p className="txt-main-content4">Weight</p>
            <div className="row-jcct-gab2">
              <input className="text-field"></input>
              <p className="txt-main-content4">kg</p>
            </div>
          </div>
        </div>
        <div className="row-jcsb-px2-gab2">
          <div className="col-jcfs-w100">
            <p className="txt-main-content4">Reason</p>
            <textarea
              id="w3review"
              name="w3review"
              rows="4"
              cols="50"
              className="text-field"
              placeholder="Remark"
            ></textarea>
          </div>
        </div>
        <div className="row-jcct-py2-gab2">
          <ButtonPrimary
            text={"Cancel"}
            className={"text-button"}
            onClick={cancelClick}
          />
          <ButtonPrimary text={"Ok"} className={"primary-button2"} />
        </div>
      </div>
    </div>
  );
}
